export default "__VITE_ASSET__Bgh39VQy__"